// eslint-disable-next-line no-unused-vars
const passwordValidator = (password, confirmPassword) => {
  const passwordRegex =
    /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/;
  if (passwordRegex.test(password)) return true;
  return false;
};

export default passwordValidator;
